<template>
  <div class="top-card-display__single-card top-card-display__single-card--bill-pay-parent">
    <div v-if="!currentAccount">
      <div class="top-card-display__single-card--pay-bill-loggedout">
        <a href="/make-payment" class="top-banner-card gds-card gds-background-green gds-invert">
          <div class="gds-card__contents">
            <h3 class="home-card__title--small-margin gds-card__title">Make Payment</h3>
            <p class="home-card__body--small-margin gds-card__body">Pay your balance online</p>
            <div class="gds-card__button gds-button-circle gds-secondary gds-icon-arrow-right"></div>
          </div>
        </a>
      </div>
    </div>
    <div v-if="currentAccount">
      <div class="top-card-display__single-card--pay-bill-loggedin">
        <div class="top-banner-card gds-card gds-data-card">
          <h3 class="gds-card__title">Current Balance</h3>
          <div v-if="!pendingPayments && amountDue > 0" class="gds-flex-container gds-flex-container--left gds-space-stack-m">
            <svg v-if="pastDue" class="gds-icon">
              <use xlink:href="/wp-content/themes/gmptwentynineteen/assets/symbol-defs.svg#gds-icon-warning" />
            </svg>
            <span class="gds-font-size-m">{{currentAccount.amountDueDate | dateDue}}</span>
          </div>
          <div v-if="!pendingPayments && amountDue <= 0" class="bill-pay-login__green-check-container gds-flex-container gds-flex-container--left gds-space-stack-m">
            <div class="bill-pay-login__green-check-cirlce">
              <svg class="bill-pay-login__white-check-icon gds-icon">
                <use xlink:href="/wp-content/themes/gmptwentynineteen/assets/symbol-defs.svg#gds-icon-check" />
              </svg>
            </div>
            <span class="gds-font-size-m">All paid up</span>
          </div>
          <div v-if="pendingPayments" class="bill-pay-login__green-check-container gds-flex-container gds-flex-container--left gds-space-stack-m">
            <div class="bill-pay-login__blue-pending-circle">
              <svg class="gds-icon">
                <use xlink:href="/wp-content/themes/gmptwentynineteen/assets/symbol-defs.svg#gds-icon-pending" />
              </svg>
            </div>
            <span class="gds-font-size-m">Payment pending</span>
          </div>
          <figure class="card__pay-bill-figure gds-card__data-container gds-flex-container">
            <div class="card__data-container--flex-container gds-flex-container">
              <div class="card__data-container--large-text gds-space-inline-s">{{amountDue | currency}}</div>
            </div>
            <div v-if="amountDue < 0" class="gds-font-size-s gds-align--text-center gds-tag gds-secondary">Credit Balance</div>
          </figure>

          <a href="/make-payment" class="gds-card__button gds-button gds-round gds-blue">Pay Now</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isPast } from 'date-fns';
import { ParseDisconnectDate } from '../utilities';
export default {
  name: "CardPayBill",
  data() {
    return {
    };
  },
  computed: {
    currentAccount() {
      return this.$store.state.user.currentAccount;
    },
    pastDue() {
      const date = ParseDisconnectDate(this.currentAccount.amountDueDate);
      return isPast(date);
    },
    amountDue() {
      if (this.currentAccount.amountDueMinusPending !== undefined) {
        return this.currentAccount.amountDueMinusPending;
      } else {
        return this.currentAccount.amountDue;
      }
    },
    pendingPayments() {
      return this.currentAccount.pendingPaymentsCount && this.currentAccount.pendingPaymentsCount > 0;
    },
  },
  async mounted() {
    // this.currentAccount.amountDue = -120;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>